



















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class LeftNavigationComponent extends Vue {
    @Prop() schema!: any;
    @Prop() selectedKey: string;

    /** left navigation menu click event */
    sub_menu_click(submenus, key){
      this.$emit('click', submenus, key);
    }
}
